import React, { useContext } from 'react';
import { Box, Card, CardBody, Text, Button, ThemeContext } from 'grommet';
import { useNavigate } from 'react-router-dom';
import { getGlassStyle } from '../helpers/GlassStyles';

export const DashboardCard = ({ card, ...rest }) => {
  const navigate = useNavigate();
  const theme = useContext(ThemeContext);
  const isDarkMode = theme.dark;

  const glass = getGlassStyle(isDarkMode, 1.015);
  const { title, description, cta, url, icon } = card;

  const handleClick = (e) => {
    // 1. Kill the focus ring immediately
    if (e.currentTarget) e.currentTarget.blur();

    // 2. Handle navigation logic
    if (url?.startsWith('http')) {
      window.open(url, '_blank');
    } else {
      navigate(url);
    }
  };

  return (
    <Card
      onClick={handleClick}
      // 3. Grommet-specific prop to prevent the brand-colored focus border
      focusIndicator={false}
      style={{ 
        ...glass.container,
        boxShadow: 'none', // Extra insurance against sticky focus shadows
        outline: 'none'    // Ensure no browser default outlines appear
      }}
      onMouseEnter={glass.hover}
      onMouseLeave={glass.leave}
      pad="medium"
      {...rest}
    >
      <CardBody gap="small" align="start" pad="none" focusable={false}>
        {icon}

        {/* Title */}
        <Text weight="bold" color="text-strong" size="large" margin={{ vertical: 'xsmall' }}>
          {title}
        </Text>

        {/* Description */}
        <Text color="text-strong" size="small">
          {description}
        </Text>

        {/* CTA Button */}
        {cta && (
          <Box margin={{ top: 'auto' }} pad={{ top: 'small' }}>
            <Button
              label={cta}
              secondary
              size="small"
              // Keep pointerEvents none so the Card handles the click, 
              // but ensure it doesn't capture focus either
              style={{ pointerEvents: 'none' }}
              tabIndex={-1} 
            />
          </Box>
        )}
      </CardBody>
    </Card>
  );
};
